import React from 'react';
import ReactPlayer from 'react-player';

const InstructionPlayer = (props) => {
    return (
        <div className='video-player'>
            <ReactPlayer
                url = {props.path}
                controls = {true}
                playing = {true}
                muted ={false}
                width ='100%'
                height ='100%'
            />
        </div>
    );
}

export default InstructionPlayer;